import { PATH_NOT_SERVED } from "@repo/core/api/path-not-served-constants";
import { readString } from "@/lib/string/read-string";
import { VERSION } from "@/lib/version/version-constants";
export function messageFrom(status: number, payload: unknown): string {
  const message = readString(payload, "message");
  // Only our own unmatched-route fallback sends this, and only on a 404: a
  // proxy or the wrong host has no such code and keeps its own diagnosis.
  if (
    status === 404 &&
    readString(payload, "error") === PATH_NOT_SERVED &&
    message
  ) {
    return `${message} hepha ${VERSION} may be ahead of the platform.`;
  }
  if (message) {
    // A 403 with HEPHA_API_KEY set is almost always the precedence rule biting.
    return status === 403 && process.env.HEPHA_API_KEY
      ? `${message} (HEPHA_API_KEY is set and takes precedence over your \`hepha login\` session; unset it to act as yourself.)`
      : message;
  }
  if (status === 401) {
    return "Unauthorized: your credential is missing, expired or revoked.";
  }
  return `Request failed with status ${status}.`;
}
